import { render, staticRenderFns } from "./circuitDetail.vue?vue&type=template&id=5652c7b3&scoped=true&"
import script from "./circuitDetail.vue?vue&type=script&lang=js&"
export * from "./circuitDetail.vue?vue&type=script&lang=js&"
import style0 from "./circuitDetail.vue?vue&type=style&index=0&id=5652c7b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5652c7b3",
  null
  
)

export default component.exports